(function ($) {
    
    var isMobile = false;
    var win = $(window);
    var winWidth;
    var winHeight;
    
    var organismeInfoTab;
    var organismeInfoTabInner;
    var organismeInfoTabBtn;
    var organismeInfoNavBtn;
    var organismeInfoLastHandle;
    var organismePrev;
    var organismeNext;

    var checkMobile = function () {
        if ($('#mobile-check').css('display') === 'none') {
            isMobile = true;
            $('html').addClass('mobile');
        } else {
            isMobile = false;
            $('html').removeClass('mobile');
        }
    };

    var initTabs = function () {
        organismeInfoTabInner.each(function () {
            var t = $(this);
            var fxOut = isMobile ? 'slideUp' : 'fadeOut';

            if (t.hasClass('hidden')) {
                t.removeClass('hidden');
                t[fxOut](0);
            }
        });
    };

    var tabsClick = function () {
        var t = $(this);
        var handle = t.attr('data-handle');
        var fxIn = isMobile ? 'slideDown' : 'fadeIn';
        var fxOut = isMobile ? 'slideUp' : 'fadeOut';
        var btn = $('.organisme-content-nav-btn[data-handle=' + handle + ']');
        var tabShown = $('.organisme-content-info-ctn.shown', organismeInfoTab);
        var tabHandle = $('.organisme-content-info-ctn[data-handle=' + handle + ']', organismeInfoTab);
        var parent = t.closest('.organisme-content-info-slide');

        if (!isMobile && !$('.organisme-content-nav-btn[data-handle=' + handle + ']').hasClass('active')) {
            organismeInfoNavBtn.removeClass('active');
            btn.addClass('active');
            organismeInfoLastHandle = handle;
            tabShown[fxOut](200, function () {
                $(this).removeClass('shown');
                parent.removeClass('opened');
                tabHandle[fxIn](200, function () {
                    $(this).addClass('shown');
                    parent.addClass('opened');
                });
            });
            updateTabsBar();
        } else if (isMobile) {
            if (tabHandle.hasClass('shown')) {
                tabHandle[fxOut](200);
                tabHandle.removeClass('shown');
                parent.removeClass('opened');
                organismeInfoLastHandle = handle;
            } else {
                tabHandle[fxIn](200);
                tabHandle.addClass('shown');
                parent.addClass('opened');
            }
        }
    };

    var resizeCheckTab = function () {
        var tabs = $('.organisme-content-info-ctn', organismeInfoTab);
        var firstTab = tabs.eq(0).attr('data-handle');
        var handle = (organismeInfoLastHandle !== undefined) ? organismeInfoLastHandle : firstTab;
        var tabsHandle = $('.organisme-content-info-ctn[data-handle=' + handle + ']', organismeInfoTab);

        if (!isMobile) {
            tabs.fadeOut(0);
            tabs.removeClass('shown');
            tabsHandle.fadeIn(0);
            tabsHandle.addClass('shown');
            $('.organisme-content-nav-btn').removeClass('active');
            $('.organisme-content-nav-btn[data-handle=' + handle + ']').addClass('active');
        } else {
            tabs.slideUp(0);
            tabs.removeClass('shown');
            $('.organisme-content-nav-btn').removeClass('active');
            organismeInfoTab.removeClass('opened');
        }
    };

    var updateTabsBar = function () {
        var item = $('.organisme-content-nav-btn span');
        var selected = $('.organisme-content-nav-btn.active');
        var offset = item.parent().position().left;
        var left = selected.position().left + (selected.width() / 2) - offset;

        item.css('left', left);
    };

    var QueryString = function (ignoreParams) {
        // This function is anonymous, is executed immediately and 
        // the return value is assigned to QueryString!
        var query_string = {};
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            // Ignore the unwanted param in the string array
            if (ignoreParams && ignoreParams.indexOf(pair[0]) > -1) {
                continue;
            }
            // If first entry with this name
            if (typeof query_string[pair[0]] === "undefined") {
                query_string[pair[0]] = decodeURIComponent(pair[1]);
                // If second entry with this name
            } else if (typeof query_string[pair[0]] === "string") {
                var arr = [query_string[pair[0]], decodeURIComponent(pair[1])];
                query_string[pair[0]] = arr;
                // If third or later entry with this name
            } else {
                query_string[pair[0]].push(decodeURIComponent(pair[1]));
            }
        }

        return query_string;
    };
    
    var stringifyQuery = function(q) {
        var s = '';
        for (var p in q) {
            if (q.hasOwnProperty(p)) {
                if (s !== '') s += '&';
                s += p;
                if (q[p] && q[p] !== undefined && q[p] !== '') {
                    s += '=' + q[p];
                }
            }
        }
        return s;
    };

    var changeArrowsLinkStep1 = function () {
        var params = QueryString(['id']);
        var query = stringifyQuery(params);
        var storedObj = sessionStorage.getItem(query);
        
        if (storedObj === null) {
            var params2 = Object.assign({}, params);
            if (!params2.maxResults) {
                params2.maxResults = 25000;
                delete params2.page;
            }
            if (!params2.distance) {
                params2.distance = 20000;
            }
            
            ajax('/action/getOrganizations?' + stringifyQuery(params2), function(response) {
                var orgs = JSON.parse(response.trim());
                var obj = [];
                
                // Sort array and transfer only required data to the saving array
                // IMPORTANT If the sorting methods here are modified, the ones in com/gmap.js must be updated too
                if (params2.sort === 'proximity' && params2.lng !== undefined && params2.lat !== undefined) {
                    var privateList = [];
                    var publicList = [];
                    
                    for (var i = 0; i < orgs.length; i++) {
                        let o = {
                            id: orgs[i].id,
                            field1: orgs[i].field1,
                            friendlyUrl: orgs[i].friendlyUrl
                        };
                        if (orgs[i].PhysicalAddressIsPrivate === 'Yes') {
                            privateList.push(o);
                        } else {
                            publicList.push(o);
                        }
                    }
                    obj = publicList.concat(privateList);
                } else {
                    orgs.sort(function compare(a, b) {
                        return removeDiacritics(decodeText(a.name).replace(/[\u0300-\u036f]/g, "")).localeCompare(
                            removeDiacritics(decodeText(b.name).replace(/[\u0300-\u036f]/g, "")));
                    });
                    if (params2.desc === 'true') {
                        for (var i = orgs.length - 1; i >= 0; i--) {
                            obj[i] = {
                                id: orgs[i].id,
                                field1: orgs[i].field1,
                                friendlyUrl: orgs[i].friendlyUrl
                            };
                        }
                    } else {
                        for (var i = 0; i < orgs.length; i++) {
                            obj[i] = {
                                id: orgs[i].id,
                                field1: orgs[i].field1,
                                friendlyUrl: orgs[i].friendlyUrl
                            };
                        }
                    }
                }
                
                // Save newly fetched organizations' data to session
                // Note: Item value can only be set as string thus stringification is necessary
                sessionStorage.setItem(query, JSON.stringify(obj));
                
                changeArrowsLinkStep2(params, query, obj);
            }, true);
        } else {
            // storedObj is a session's string value so we must use json parser
            changeArrowsLinkStep2(params, query, JSON.parse(storedObj));
        }
    };

    var changeArrowsLinkStep2 = function (params, query, obj) {
        var id = $('.organisme-detail-ctn').attr('data-id');
        var index = -1;
        var pageRechercheUrl = $('.organisme-detail-ctn').attr('data-nav-url');
        var urlPrev = pageRechercheUrl;
        var urlNext = pageRechercheUrl;
        
        for (var i = 0; i < obj.length; i++) {
            if (obj[i].field1 !== undefined && obj[i].field1.toString() === id) {
                index = i;
                break;
            }
        }

        // When there is no 'target' param in the query and if the document is not in the iframe "rechercheFrame", pass the 'id' param instead of friendlyUrl because all links direct within the iframe (of rechercheframe)
        if (!params.target && document.querySelector('.recherche-frame-ctn')) {
            var idBefore, idAfter;
            
            if (index === 0) {
                idBefore = obj[obj.length - 1].id;
            } else {
                idBefore = obj[index - 1].id;
            }
            if (index === obj.length - 1) {
                idAfter = obj[0].id;
            } else {
                idAfter = obj[index + 1].id;
            }
            if (query !== '') {
                urlPrev += '?' + query + '&id=' + idBefore;
                urlNext += '?' + query + '&id=' + idAfter;
            } else {
                urlPrev += '?id=' + idBefore;
                urlNext += '?id=' + idAfter;
            }
        } else {
            var urlBefore, urlAfter;
            
            if (index === 0) {
                urlBefore = obj[obj.length - 1].friendlyUrl;
            } else {
                urlBefore = obj[index - 1].friendlyUrl;
            }
            if (index === obj.length - 1) {
                urlAfter = obj[0].friendlyUrl;
            } else {
                urlAfter = obj[index + 1].friendlyUrl;
            }
            urlPrev += '/' + urlBefore;
            urlNext += '/' + urlAfter;
            if (query !== '') {
                urlPrev += '?' + query;
                urlNext += '?' + query;
            }
        }

        if (index !== -1) {
            organismePrev.attr('href', urlPrev).removeClass('disabled');
            organismeNext.attr('href', urlNext).removeClass('disabled');
        }
    };

    win.load(function () {
        winHeight = win.height();
        winWidth = win.width();
        
        organismeInfoTab = $('.organisme-content-info-slide');
        organismeInfoTabInner = $('.organisme-content-info-ctn', organismeInfoTab);
        organismeInfoTabBtn = $('.organisme-intro-slide-tiroir-btn', organismeInfoTab);
        organismeInfoNavBtn = $('.organisme-content-nav-btn');
        organismePrev = $('.organisme-header-nav-link.prev');
        organismeNext = $('.organisme-header-nav-link.next');

        organismeInfoTabBtn.add(organismeInfoNavBtn).click(tabsClick);
        
        checkMobile();
        initTabs();
        if (organismePrev.length !== 0) {
            changeArrowsLinkStep1();
        }
    });
    
    win.resize(function () {
        if (win.width() != winWidth) {
            winHeight = win.height();
            winWidth = win.width();

            resizeCheckTab();
        }
    });
    
})(jQuery);